import type { ComponentProps } from 'react';
import React from 'react';
import NextImage from 'next/image';
import { Box, Image } from '@skin-seoul/design-system';
type BannerMediaProps = ComponentProps<typeof Image> & ComponentProps<typeof NextImage>;
const BannerMedia = (props: BannerMediaProps) => {
  const srcString = typeof props.src === 'string' ? props.src : '';
  const isVideo = srcString.toLowerCase().endsWith('.mp4');
  if (isVideo) {
    return <Box position="relative" width="100%" display={props.display}>
        <video src={srcString} autoPlay loop muted playsInline aria-label={props.alt || 'Banner video'} style={{
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
        objectPosition: 'center'
      }} />
      </Box>;
  }
  return <Box position="relative" width="100%" display="block" data-sentry-element="Box" data-sentry-component="BannerMedia" data-sentry-source-file="BannerMedia.tsx">
      <Image asChild {...props} alt={props.alt} data-sentry-element="Image" data-sentry-source-file="BannerMedia.tsx">
        <NextImage src={props.src} alt={props.alt} width={0} height={0} sizes="100vw" style={{
        width: '100%',
        height: 'auto',
        objectFit: 'cover',
        objectPosition: 'center'
      }} data-sentry-element="NextImage" data-sentry-source-file="BannerMedia.tsx" />
      </Image>
    </Box>;
};
export default BannerMedia;